module.exports = __webpack_public_path__ + "b19a14c57b50536a4d99fea8df33438a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/static/fonts/futura-light-webfont.svg
 ** module id = 1534
 ** module chunks = 0
 **/